import { Space } from "antd";
import { FormattedMessage } from "react-intl";

type Props = {
  onModalEditModeClickedHandler: () => void;
};

export const ModalEditFixtureAction = ({ onModalEditModeClickedHandler }: Props) => {
  return (
    <Space onClick={() => onModalEditModeClickedHandler()}>
      <i className="fas fa-pen-to-square mr-2" />
      <FormattedMessage id="fixtureListPage.table.column.actions.modalEdit" />
    </Space>
  );
};
